import React, { useState } from 'react'
import styled from 'styled-components'
import Avatar from 'react-avatar'
import TimeAgo from 'javascript-time-ago'
import ReactTimeAgo from 'react-time-ago'
import enMY from 'javascript-time-ago/locale/en-MY'

// TimeAgo.addDefaultLocale(enMY)

const Message = styled.div`
  text-align: left;
  margin: 12px 0;

  .message {
    border-radius: 15px;
    padding: 8px;
    color: #3c3c3c;
    background: #fff;
    border-radius: 8px;
    padding-inline: 14px;
    width: 100%;
  }
  .received {
  }
  .sent {
    align-items: end;
  }
  .sender {
    font-size: 10px;
    min-width: 100px;
    gap: 8px;

    .name {
      margin-top: 3px;
      color: black;
      text-transform: capitalize;
      font-size: 0.875rem !important;
    }

    .timestamp {
      font-size: 0.8em;
    }
  }
  .chat-profile-image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;

    .avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
`

const ChatMessage = React.memo(({ dbMessage, dbUser, dbTimestamp, dbUserAvatarUrl, dbUserId, currentUser, toggleAvatar }) => {
  const received = dbUser !== currentUser.fullName
  const [showAvatar, setShowAvatar] = useState(true)

  return (
    <Message>
      <div className={`d-flex flex-column mb-2 ${received ? 'received' : 'sent'}`}>
        <div className="d-flex align-items-center sender mb-2">
          <div onClick={() => toggleAvatar(dbUserId)} className="chat-profile-image d-block">
            {dbUserAvatarUrl ? (
              <>
                <img
                  alt="avatar"
                  src={dbUserAvatarUrl}
                  width="30px"
                  onError={(e) => {
                    e.target.onerror = null
                    setShowAvatar(false)
                  }}
                  className={showAvatar ? 'avatar' : 'd-none'}
                />
                <Avatar name={dbUser} size="30" round className={!showAvatar ? 'd-block' : 'd-none'} />
              </>
            ) : (
              <Avatar name={dbUser} size="30" round />
            )}
            {/* {
                dbUserAvatarUrl ?
                <img src={dbUserAvatarUrl} width="30px" className="avatar" alt="profile-image" />
                :
                <Avatar name={dbUser} size="30" round />
              } */}
            {/* <Avatar name={dbUser} size="30" round /> */}
          </div>
          <div>
            <div className="name">{dbUser.toLowerCase()}</div>
            <small className="text-muted d-block timestamp">{dbTimestamp && <ReactTimeAgo date={dbTimestamp} />}</small>
          </div>
        </div>
        <span className="message">{dbMessage}</span>
      </div>
    </Message>
  )
})

export default ChatMessage
